import * as React from "react";

import "./subscription-modal.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {Load2}             from "@Common/react/load2";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {ConfirmDialog}     from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {needsConfirmation} from "@Common/ui-components/needs-confirmation/needs-confirmation";

export const SubscriptionModal = ({urlParam, refresh, referenceUrl, next: rootNext}) => cs(
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ["modal", ({confirmDialog}, next) => ModalService3({
        xdQaName: "Subscription Modal",
        top: 20,
        width: 400,
        urlParam,
        next, rootNext,
        onPassiveClose: () => needsConfirmation({
            confirmDialog,
            message: "Leave subscription checkout?",
        })
        
    })],
    consumeContext("apis"),
    ["hostedPage", ({apis, modal}, next) => Load2({
        fetch: () =>  apis.next.subscription.create({planId: modal.params.planId, referenceUrl: referenceUrl ?? "/manage-subscriptions"}),
        next,
    })],
    ({hostedPage, modal}) => (
        <div className="subscription-modal-p2r" xd-qa-type="modal" xd-qa-name="Terms">
            {hostedPage.loading ? (
                <div className="content">
                    <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                        Loading...
                    </div>
                </div>
            ) : (hostedPage?.value?.statusCode == "success" && hostedPage?.value?.data?.url) ? (
                <iframe className="iframe" src={hostedPage.value.data.url} title="Subscription Iframe" scrolling="no"/>
            ) : hostedPage?.value?.message ? (
                <div className="content">
                    <div className="message" xd-qa-type="label" xd-qa-name="error">
                        {hostedPage.value.message}
                    </div>
                    {hostedPage.value?.statusCode && <div className="message" xd-qa-type="label" xd-qa-name="error">
                        {hostedPage.value.statusCode}
                    </div>}
                    <button className="cancel" onClick={() => {modal.close(); refresh()}} xd-qa-type="button" xd-qa-name="Reload Page">Reload Page</button>
                    {hostedPage.value?.internalMessage && <div className="internal-message" xd-qa-type="label" xd-qa-name="internal">
                        Internal: <pre>{JSON.stringify(JSON.parse(hostedPage.value?.internalMessage), null, 2)}</pre>
                    </div>}
                </div>
            ) : (
                <div className="content">
                    <div className="loading" xd-qa-type="label" xd-qa-name="error">
                        Something went wrong!
                    </div>
                </div>
            )}
        </div>
    ),
);
